 document.addEventListener("DOMContentLoaded", function() {
      const items = document.querySelectorAll(".faq-accordion__item");

      items.forEach(item => {
        const button = item.querySelector(".faq-accordion__title");
        const icon = item.querySelector(".faq-accordion__icon");
        button.addEventListener("click", () => {
          // Close all other accordions
          items.forEach(i => {
            if (i !== item) {
              i.classList.remove("active");
              i.querySelector(".faq-accordion__content").style.display = "none";
              i.querySelector(".faq-accordion__icon").textContent = "+";
            }
          });

          // Toggle current one
          const content = item.querySelector(".faq-accordion__content");
          const isActive = item.classList.toggle("active");
          if (isActive) {
            content.style.display = "block";
            icon.textContent = "–";
          } else {
            content.style.display = "none";
            icon.textContent = "+";
          }
        });
      });


      //sizechart
      const btn = document.querySelector('.size-chart-btn');
      const modal = document.getElementById('size-chart-modal');
      const close = document.querySelector('.size-chart-close');

      if (btn && modal && close) {
        btn.addEventListener('click', () => {
          modal.style.display = 'flex';
        });
        close.addEventListener('click', () => {
          modal.style.display = 'none';
        });
        modal.addEventListener('click', (e) => {
          if (e.target === modal) modal.style.display = 'none';
        });
      }

    });


  (function () {

    var isDesignMode = document.documentElement.classList.contains('shopify-design-mode');


  function waitForSlick(callback) {
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
      callback();
    } else {
      setTimeout(function () {
        waitForSlick(callback);
      }, 50);
    }
  }

  function updateArrows(slick, currentSlide) {
    var slidesToShow = slick.options.slidesToShow;
    var slideCount = slick.slideCount;
    var lastSlide = slideCount - slidesToShow;

    // First slide
    if (currentSlide === 0) {
      jQuery(slick.$prevArrow).hide();
      jQuery(slick.$nextArrow).show();
    }
    // Last slide
    else if (currentSlide >= lastSlide) {
      jQuery(slick.$nextArrow).hide();
      jQuery(slick.$prevArrow).show();
    }
    // Middle
    else {
      jQuery(slick.$prevArrow).show();
      jQuery(slick.$nextArrow).show();
    }
  }
  
  function updateLastVisibleOverlay(slick) {
  // Remove previous overlay class
  jQuery(slick.$slides).removeClass('is-last-visible');

  var startIndex = slick.currentSlide;
  var endIndex = startIndex + slick.options.slidesToShow - 1;

  // Add overlay only if not at the very end
  if (endIndex < slick.slideCount - 1) {
    jQuery(slick.$slides).eq(endIndex).addClass('is-last-visible');
  }
}


  function initTodayTopPicks(section) {

      if (isDesignMode) return
      
    var slider = section.querySelector('.top-picks-slider');
    if (!slider) return;

    var $slider = jQuery(slider);
    if ($slider.hasClass('slick-initialized')) return;

    $slider
      .on('init', function (event, slick) {
        updateArrows(slick, 0);
        updateLastVisibleOverlay(slick);
      })
      .on('afterChange', function (event, slick, currentSlide) {
        updateArrows(slick, currentSlide);
        updateLastVisibleOverlay(slick);
      });

    $slider.slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      speed: 400,
      appendDots: jQuery(section).find('.top-picks-dots'),
    
      prevArrow: `
      <button type="button" class="slick-prev top-picks-arrow">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      `,
      nextArrow: `
      <button type="button" class="slick-next top-picks-arrow">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
      `,


      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 5 } },
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 640, settings: { slidesToShow: 2 } }
      ]
    });
  }

  function initAll() {
    document.querySelectorAll('.today-top-picks').forEach(function (section) {
      initTodayTopPicks(section);
    });
  }

  // Initial load
  waitForSlick(initAll);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('today-top-picks')) {
      waitForSlick(function () {
        initTodayTopPicks(event.target);
      });
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
  if (event.target.classList.contains('today-top-picks')) {
    waitForSlick(function () {
      initTodayTopPicks(event.target);
    });
  }
});



})();

